<template>
  <v-autocomplete
      v-model="options"
      :items="parkList"
      :label="forVender?(!!venderId?label:'请选择供应商'):label"
      :rules="rules"
      :disabled="forVender && !venderId"
      item-text="name"
      item-value="id"
      clearable
      :outlined="outlined"
      dense
      :return-object="returnObject"
  ></v-autocomplete>
</template>

<script>
import ParkApi from "@/api/appointment/park/ParkApi";

export default {
  name: "ParkSelect",
  data(){
    return {
      parkList:[],
    }
  },
  props: {
    value: {
      type: [Number,String,Object],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default :''
    },
    rules:{
      type: Array
    },
    venderId:{
      type: String
    },
    forVender:{
      type: Boolean,
      default: true
    },
    returnObject:{
      type: Boolean,
      default: false,
    },
    outlined:{
      type: Boolean,
      default: true,
    }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  created() {
    if(!this.forVender){
      this.listPark();
    }else if(this.venderId){
      this.listPark(this.venderId);
    }
  },

  computed: {
    options: {
      get: function () {
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        console.log(val);
        this.$emit('modify', val) //通过$emit触发父组件
      },
    },
  },
  watch:{
    venderId(val){
      this.listPark(val);
    }
  },
  methods:{
    async listPark(venderId) {
      let me = this;
      let resp = await ParkApi.all({venderId:venderId});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        this.$dialog.error({
          title:'错误',
          text:'获取供应商失败'
        })
        return;
      }
      this.parkList = data.data;
    },
  }
}
</script>

<style scoped>

</style>